import { AudienceOptions, SendOptions } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  title: 'Pushmelding campagne aanmaken',
  sent_title: 'Melding in wachtrij',
  sent_subtitle:
    'Je pushmelding is verzonden naar Apple en Google. Bezorgbevestigingen zijn beschikbaar na ongeveer 15 minuten.',
  sent_info_banner:
    'Je kunt dit venster sluiten. We blijven controleren en de bezorgstatistieken van de campagne automatisch bijwerken.',
  circles: {
    sent_label: 'Verzonden',
    sent_sub: 'Gepusht naar abonnees',
    delivered_label: 'Bezorgd',
    delivered_sub: 'Wachten op Apple & Google',
    delivered_ready_short: 'Gereed',
    delivered_ready_sub: 'Vernieuwen voor de laatste statistieken',
  },
  scheduled_title: 'Campagne ingepland',
  scheduled_body_line_1: 'Je pushmelding is ingepland voor {{when}}.',
  scheduled_body_line_2:
    'We verzenden deze automatisch op dat moment. Bezorgbevestigingen van Apple en Google zijn beschikbaar ongeveer 15 minuten na verzending.',
  recipients_count_one: 'Verzonden naar {{count}} abonnee.',
  recipients_count_other: 'Verzonden naar {{count}} abonnees.',
  close: 'Sluiten',
  sections: {
    message: 'Bericht',
    audience: 'Doelgroep',
    when: 'Verzenddatum',
    review: 'Beoordelen',
  },
  stepper: {
    message: 'Bericht',
    audience_when: 'Verzenddatum',
    review: 'Beoordelen',
  },
  blocked_reasons: {
    title_required: 'Voeg een titel toe om door te gaan.',
    body_required: 'Voeg een berichttekst toe om door te gaan.',
    offer_required: 'Kies een aanbieding om door te gaan.',
    promo_code_required: 'Kies een promocode om door te gaan.',
    send_option_required: 'Kies een verzendoptie om door te gaan.',
    scheduled_at_required: 'Kies een datum en tijd om door te gaan.',
  },
  fields: {
    title: {
      label: 'Titel',
      placeholder: 'Meldingstitel invoeren',
    },
    body: {
      label: 'Berichttekst',
      placeholder: 'Voer je bericht in',
    },
    audience: {
      label: 'Doelgroep',
    },
    send_options: {
      label: 'Verzendopties',
    },
    date_and_time: {
      label: 'Datum & tijd',
      placeholder: 'Datum & tijd selecteren',
    },
  },
  send_options: {
    [SendOptions.Now]: 'Nu verzenden',
    [SendOptions.Schedule]: 'Inplannen',
  },
  send_option_cards: {
    now: {
      title: 'Nu verzenden',
      description: 'Direct naar alle abonnees verzenden.',
    },
    schedule: {
      title: 'Inplannen',
      description: 'Kies een datum en tijd in de toekomst.',
    },
  },
  campaign_type_cards: {
    promotional: {
      title: 'Promotioneel 🚀',
      description: 'Promoot een aanbieding of promocode.',
    },
    informational: {
      title: 'Informationeel ℹ️',
      description: 'Deel nieuws of een update — zonder korting.',
    },
  },
  audience: {
    [AudienceOptions.All]: 'Alle gebruikers ({{count}} apparaat)',
  },
  preview: {
    title: 'Voorbeeld',
    notifications: {
      title: 'Je meldingstitel verschijnt hier',
      body: 'Je berichttekst wordt hier weergegeven met alle details...',
      now: 'Nu',
    },
    estimated_reach: 'Bereik',
  },
  summary: {
    title: 'Samenvatting',
    reach: 'Bereik',
    when: 'Wanneer',
    campaign_type: 'Campagnetype',
    promo_code: 'Promocode',
    offer: 'Aanbieding',
    test_audience: 'Stuur eerst een testpush',
  },
  alerts: {
    daily_limit_reached: {
      title: 'Dagelijkse verzendlimiet bereikt',
      description:
        'Meer dan 1 pushmelding per dag maakt gebruikers ontevreden en kan leiden tot app-verwijderingen. Daarom beperken we handmatige pushes tot 1/dag. Plan deze voor morgen in.',
    },
    offer_not_sendable: {
      title: 'Aanbieding geldt niet vandaag',
      description: 'Kies een datum in de toekomst.',
    },
  },
  buttons: {
    send_now: 'Nu verzenden',
    save: 'Opslaan',
    save_as_draft: 'Opslaan als concept',
    send_test: 'Test verzenden',
    draft_with_ai: 'Concept met AI',
    back: 'Terug',
    next: 'Volgende',
  },
  feedback: {
    success: 'Campagne succesvol opgeslagen',
    promo_code_expired: 'Promocode verlopen',
    error: 'Kon de campagne niet opslaan. Controleer je verbinding en probeer het opnieuw.',
  },
};
